// extracted by mini-css-extract-plugin
export default {"inputNum":"IpInput_inputNum__XmsCq"};